"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntlWrapper = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var Locale_1 = require("./Locale");
var utils_1 = require("./TranslationsCustomizationProvider/utils");
var messagesMap_1 = require("./messagesMap");
/**
 * @internal
 */
exports.IntlWrapper = function (_a) {
    var _b = _a.locale, locale = _b === void 0 ? Locale_1.DefaultLocale : _b, children = _a.children;
    /**
     * Because of issues described in the ticket FET-855, we decided to use this workaround.
     * After the issues that are described in the ticket are solved or at least reduced,
     * this workaround can be removed.
     */
    var settings = window.gdSettings;
    var messages = react_1.useMemo(function () { return utils_1.pickCorrectWording(messagesMap_1.messagesMap[locale], settings); }, [locale, settings]);
    return (react_1.default.createElement(react_intl_1.IntlProvider, { locale: locale, messages: messages }, children));
};
//# sourceMappingURL=IntlWrapper.js.map